import React from 'react'

import { FormattedMessage, useIntl } from 'react-intl'

import Skeleton from 'app/components/base/Skeleton'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import { pluralize } from 'app/utils/helpers/functions.helpers'

interface SearchTotalProps {
  articlesCount: number
  keyword: string
  isLoading: boolean
}

const SearchTotal = ({
  articlesCount,
  keyword,
  isLoading
}: SearchTotalProps) => {
  const { formatMessage } = useIntl()

  const plural = pluralize(
    articlesCount,
    formatMessage({ defaultMessage: 'result' })
  )

  return (
    <Stack direction="column" spacing={1}>
      <Skeleton
        loading={isLoading}
        sx={{ width: { xs: '20%', md: '10%' }, height: 20 }}
      >
        <Text variant="h5">
          <FormattedMessage defaultMessage="Search results" />
        </Text>
      </Skeleton>

      <Skeleton
        loading={isLoading}
        sx={{ width: { xs: '30%', md: '20%' }, height: 20 }}
      >
        <Text variant="subtitle1">
          <FormattedMessage
            defaultMessage='{count} {plural} for "{keyword}"'
            values={{ count: articlesCount, plural, keyword }}
          />
        </Text>
      </Skeleton>
    </Stack>
  )
}

export default SearchTotal
